import FilterButtonItem from './src/filter-button.vue';

FilterButtonItem.install = function (Vue) {
  Vue.component(FilterButtonItem.name, FilterButtonItem);
};

export default FilterButtonItem;
